/**
 * Human-readable scope label for a role, sourced directly from `role.scope`
 * ('system' | 'tenant' | 'platform') — never inferred from tenantId
 * emptiness, since a platform-scope role is also tenant-less but is not a
 * system role.
 */
export function roleScopeLabel(role: { scope: string }): 'System' | 'Tenant' | 'Platform' {
  switch (role.scope) {
    case 'system':
      return 'System';
    case 'platform':
      return 'Platform';
    default:
      return 'Tenant';
  }
}
